export const initialState = {
  loadingStatus: {
    paperworkListLoading: false,
  },
  error: '',
  paperworkList: [],
};
